import { IsBoolean, IsIn, IsInt, IsNumber, IsOptional, IsString, Min } from 'class-validator';

export class SetCuotaDto {
  @IsOptional()
  @IsInt()
  @Min(0)
  limite_tokens_mensual?: number;

  @IsOptional()
  @IsIn(['PROPIA', 'PLATAFORMA'])
  credencial_modo?: string;
}

export class TarifaDto {
  @IsString()
  proveedor: string;

  @IsString()
  modelo: string;

  @IsNumber()
  @Min(0)
  precio_in_por_1m: number;

  @IsNumber()
  @Min(0)
  precio_out_por_1m: number;

  @IsOptional()
  @IsBoolean()
  activo?: boolean;
}
